/**
 * Allowlist hrefs before binding them onto <a> tags.
 * Vue 2 does not strip javascript: / data: URLs.
 * Shared by page nodes and sanitizeRenderedHtml.
 */

import { vueEnv } from '@/globals';

const ALLOWED_SCHEMES = ['http:', 'https:', 'mailto:', 'tel:'];
// Intentionally matches C0 and DEL so scheme checks cannot be smuggled.
// eslint-disable-next-line no-control-regex
const STRIP_CONTROLS = /[\x00-\x1f\x7f]/g;

function resolveOrigin() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return 'https://localhost';
}

function schemeOf(cleaned) {
  const match = String(cleaned).match(/^([a-zA-Z][a-zA-Z+\-.]*):/);
  return match ? `${match[1].toLowerCase()}:` : '';
}

function hasDisallowedScheme(cleaned) {
  const scheme = schemeOf(cleaned);
  return !!scheme && !ALLOWED_SCHEMES.includes(scheme);
}

function isProtocolRelative(cleaned) {
  return cleaned.replace(/\\/g, '/').startsWith('//');
}

export function safeHref(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return '';

  const cleaned = trimmed.replace(STRIP_CONTROLS, '');
  if (!cleaned || isProtocolRelative(cleaned)) return '';
  if (hasDisallowedScheme(cleaned)) return '';

  try {
    const parsed = new URL(cleaned, resolveOrigin());
    if (!ALLOWED_SCHEMES.includes(parsed.protocol)) return '';
    return cleaned;
  } catch (err) {
    return cleaned;
  }
}

export function helpStoryHref(slug) {
  const path = String(slug || '')
    .replace(/^\/+/, '')
    .trim();
  if (!path) return '';
  const host = String(vueEnv('help_host') || '')
    .replace(/^https?:\/\//, '')
    .replace(/\/+$/, '');
  if (!host) return `/${path}`;
  return safeHref(`https://${host}/${path}`);
}
